import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "../HomePage/HomePage";
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SponsorshipPage from "../SponsorshipPage/SponsorshipPage";
import ServiceSinglePage from "../ServiceSinglePage/ServiceSinglePage";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectSinglePage from "../ProjectSinglePage/ProjectSinglePage";
import TestimonialsPage from "../testimonialsPage/testimonialsPage";
import ContactPage from "../ContactPage/ContactPage";
import LoginPage from "../LoginPage/index";
import ForgotPassword from "../ForgotPassword/index";
import Register from "../SignUpPage/index";
import ErrorPage from "../ErrorPage/ErrorPage";
import ThankYouPage from "../ThankYouPage/ThankYouPage";
import PrivacePage from "../PrivacePage/PrivacePage";
import TermsPage from "../TermsPage/TermsPage";
import GlobalTourPage from "../GlobalTourPage/GlobalTourPage";
import SummitObjectivePage from "../SummitObjectivePage/SummitObjectivePage";
import GalleryPage from "../GalleryPage/GalleryPage";
import SupportPage from "../SupportPage/SupportPage";
import AnalyticsPage from "../AnalyticsPage/AnalyticsPage";
import AdminPage from "../AdminPage/AdminPage";
import AdminLogin from "../AdminPage/AdminLogin";
import GoogleAnalytics from "../../components/GoogleAnalytics/GoogleAnalytics";
import VisitorTracker from "../../components/VisitorTracker/VisitorTracker";
import CanonicalFromRoute from "../../components/CanonicalFromRoute/CanonicalFromRoute";
import BlogPage from "../BlogPage/BlogPage";
import BlogSinglePage from "../BlogSinglePage/BlogSinglePage";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <CanonicalFromRoute />
        <GoogleAnalytics />
        <VisitorTracker />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="summit-objective" element={<SummitObjectivePage />} />
          <Route path="global-tour" element={<GlobalTourPage />} />
          <Route path="sponsorship" element={<SponsorshipPage />} />
          <Route path="services" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="project" element={<ProjectPage />} />
          <Route path="project-single/:slug" element={<ProjectSinglePage />} />
          <Route path="testimonials" element={<TestimonialsPage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogSinglePage />} />
          <Route path="support" element={<SupportPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="analytics/*" element={<AnalyticsPage />} />
          <Route path="admin/login" element={<AdminLogin />} />
          <Route path="admin/*" element={<AdminPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="forgot" element={<ForgotPassword />} />
          <Route path="register" element={<Register />} />
          <Route path="thank-you" element={<ThankYouPage />} />
          <Route path="404" element={<ErrorPage />} />
          <Route path="privacy" element={<PrivacePage />} />
          <Route path="terms-and-conditions" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
